import * as THREE from 'three';

const BUBBLE_RADIUS = 3;

/** Blue translucent dome shown around the player while knocked (DBNO). */
export class FpsKnockBubble {
  private readonly mesh: THREE.Mesh;
  private active = false;
  private pulseT = 0;

  constructor(private readonly scene: THREE.Scene) {
    const geo = new THREE.SphereGeometry(BUBBLE_RADIUS, 28, 18);
    const mat = new THREE.MeshBasicMaterial({
      color: 0x44aaff,
      transparent: true,
      opacity: 0.22,
      depthWrite: false,
      side: THREE.DoubleSide,
    });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.visible = false;
    this.scene.add(this.mesh);
  }

  setActive(on: boolean): void {
    this.active = on;
    this.mesh.visible = on;
    if (!on) this.pulseT = 0;
  }

  update(dt: number, x: number, y: number, z: number): void {
    if (!this.active) return;
    this.pulseT += dt;
    const pulse = 0.88 + Math.sin(this.pulseT * 4.4) * 0.12;
    this.mesh.scale.setScalar(pulse);
    const mat = this.mesh.material as THREE.MeshBasicMaterial;
    mat.opacity = 0.17 + Math.sin(this.pulseT * 3.5) * 0.09;
    this.mesh.position.set(x, y + 1.05, z);
  }

  dispose(): void {
    this.scene.remove(this.mesh);
    this.mesh.geometry.dispose();
    (this.mesh.material as THREE.Material).dispose();
  }
}
